export const getItemsAdded = (currentLineItems, previousLineItems) => {
  // Create maps to track quantities by SKU
  const previousQuantities = {};
  previousLineItems.forEach(item => {
    const { sku } = item.variant;
    previousQuantities[sku] = (previousQuantities[sku] || 0) + item.quantity;
  });

  const currentQuantities = {};
  const skuToItem = {};
  currentLineItems.forEach(item => {
    const { sku } = item.variant;
    currentQuantities[sku] = (currentQuantities[sku] || 0) + item.quantity;
    skuToItem[sku] = item; // Keep reference to the item for this SKU
  });

  const addedItems = [];
  
  // For each SKU, calculate the quantity difference and create items with correct quantities
  Object.keys(currentQuantities).forEach(sku => {
    const previousQty = previousQuantities[sku] || 0;
    const currentQty = currentQuantities[sku] || 0;
    const addedQty = currentQty - previousQty;
    
    if (addedQty > 0) {
      // Create a new item with only the added quantity
      const addedItem = {
        ...skuToItem[sku],
        quantity: addedQty
      };

      // Add discount object if discounts_json exists
      if (skuToItem[sku]?.custom?.fields?.discounts_json) {
        try {
          const discountsData = JSON.parse(skuToItem[sku].custom.fields.discounts_json);

          if (discountsData?.length) {
            addedItem.discount = {
              type: discountsData[0].type || '',
              currencyCode: discountsData[0].currencyCode || 'USD',
              centAmount: discountsData[0].cent_amount || 0,
              fractionDigits: discountsData[0].fractionDigits || 2,
            };
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn('Failed to parse discounts_json:', error);
        }
      }

      // Add price object from the item's price field
      if (skuToItem[sku]?.price) {
        addedItem.price = {
          type: skuToItem[sku]?.price?.value?.type || '',
          currencyCode: skuToItem[sku]?.price?.value?.currencyCode || '',
          centAmount: skuToItem[sku]?.price?.value?.centAmount || 0,
          fractionDigits: skuToItem[sku]?.price?.value?.fractionDigits || 0,
        };
      }

      addedItems.push(addedItem);
    }
  });

  return addedItems;
}

export const getCustomLineItemsAdded = ({
  customLineItems = [],
  previousCustomLineItems = [],
}) =>
  customLineItems.filter(
    (item) =>
      !previousCustomLineItems.find((prevItem) => prevItem.id === item.id),
  );
